import { Injector } from "@angular/core";

/*
 *  Utile per instanziare un servizio manualmente 
 *  Anche fuori dalla classe di un component
 *
 *  es: 
 *  const instance = InjectorService.inject.get(MyserviceClass);
 */ 

export class InjectorService {
  static inject: Injector;
}
